import { SVLoader, SVTabs } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import TransactionRequestList from '@/components/transactionRequests/TransactionRequestsList';
import { useGetBankAccountDetails } from '@/hooks/requests/useBankAccounts';
import { TRANSACTION_REQUEST_STATUS } from '@/types/transactionRequests';
import { Card, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

export default function TransactionRequestListPage() {
  const { bankAccountId = '' } = useParams();
  const { accountDetails, accountsDetailsIsPending } =
    useGetBankAccountDetails(bankAccountId);

  if (accountsDetailsIsPending) {
    return (
      <DefaultLayout header="Transaction Requests">
        <SVLoader />
      </DefaultLayout>
    );
  }

  if (!accountDetails) {
    return (
      <DefaultLayout header="Transaction Requests">
        <Card>
          <Typography>
            Something went wrong retreiving the bank account transaction
            requests. Our team has been notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout header="Transaction Requests">
      <Card>
        <Typography variant="h5" mb={2}>
          History
        </Typography>
        <SVTabs
          headers={['Approved', 'Declined', 'Canceled', 'Expired']}
          panels={[
            <TransactionRequestList
              key="approved-list"
              status={TRANSACTION_REQUEST_STATUS.Approved}
              bankAccountId={bankAccountId}
            />,
            <TransactionRequestList
              key="declined-list"
              status={TRANSACTION_REQUEST_STATUS.Declined}
              bankAccountId={bankAccountId}
            />,
            <TransactionRequestList
              key="canceled-list"
              status={TRANSACTION_REQUEST_STATUS.Canceled}
              bankAccountId={bankAccountId}
            />,
            <TransactionRequestList
              key="expired-list"
              status={TRANSACTION_REQUEST_STATUS.Expired}
              bankAccountId={bankAccountId}
            />,
          ]}
        />
      </Card>
    </DefaultLayout>
  );
}
